<template>
	<div>
		<van-field v-model="selectValue" :placeholder="placeholder" type="text" :label="label" :disabled='disabled'
			@focus="onFocus" />
		<div class="van-hairline--bottom"></div>
		<van-action-sheet v-model="show" name="abc" :title="title" class="action-sheet-box">
			<!-- 搜索区域 -->
			<van-search v-model="search" placeholder="请输入关键词" @input="OnInput"></van-search>
			<van-cell v-for="(item,index) in dataList.filter(obj=>obj.dictItemName.indexOf(search)!=-1)" :key="index"
				:title="item.dictItemName" :is-link="isLink" @click="onSelect(item)">
			</van-cell>
		</van-action-sheet>
	</div>
</template>
<script>
	export default {
		props: {
			dictguid: {
				type: String
			},
			mark: {
				type: String,
				default: ""
			},
			placeholder: {
				type: String,
				default: '请选择'
			},
			label: {
				type: String,
				default: '未定义'
			},
			title: {
				type: String,
				default: '请选择'
			},
			guid: {
				type: String,
			},
			value: {},
			// 增加了动态绑定disabled功能
			disabled: {}
		},
		data() {
			return {
				form: {
					token: ''
				},
				search: "",
				selectValue: this.value,
				isLink: true,
				// readonly: true,
				show: false,
				dataList: [],
				token: '',
				companyid: ''
			}
		},
		watch: {
			value(newVal) {
				this.selectValue = newVal
			}
		},
		methods: {
			onFocus: function() {
				this.show = true
			},
			//搜索框变化事件
			OnInput: function() {
				//this.LoadItem()
			},
			onSelect: function(item) {
				// 默认情况下点击选项时不会自动收起
				// 可以通过 close-on-click-action 属性开启自动收起
				this.show = false
				this.selectValue = item.dictItemName
				this.$emit('input', this.selectValue)
				this.$emit('update:selectkey', item.guid)
				// this.$emit('getGuid',item.guid)
				console.log(this.selectValue);
				console.log(item.guid);
			},
			LoadDictItem: function() {

				let args = {
					dictGuid: this.dictguid,
					dictitemremark2: this.mark,
					pageIndex: 1,
					pageSize: 99999,
					recordCount: 0,
					menuid: this.$utils.MenuEnum.dictitem
				}
				var that = this
				this.$http.defaults.headers.common["MenuId"] = this.$utils.MenuEnum.dictitem;
				that.$utils.HttpPost(this.$utils.Url.system + '/api/APISEMP_DictItem/AllList', args, function(data) {
					data.data.forEach((item) => {
						for (var key in item) {
							item[that.$utils.toLowerCaseFirst(key)] = item[key]
						}
					})
					console.log(data.data)
					if (that.dictguid == '2') {
						for (var i = 0; i < data.data.length; i++) {
							var name = data.Data[i]["dictItemName"] + '(' + data.data[i]["dictItemRemark"] +
								')'
							var arg = {
								DictItemID: data.data[i]["dictID"],
								DictItemName: name
							}
							that.dataList.push(arg)
						}
					} else {
						that.dataList = data.data
					}
				}, null, null)
			}
		},
		mounted: function() {
			this.LoadDictItem()
		}
	}
</script>
<style scoped>
</style>
